import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from 'app/core/i18n/language.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

/**
 * Manda el idioma de la interfaz en `X-Lang` a la API, para que los mensajes de
 * error lleguen en ese idioma (el back los traduce en su filtro de excepciones;
 * sin header salen en español). No es Accept-Language porque ese lo pone el
 * navegador con su propio idioma. El back debe tener X-Lang en los headers
 * permitidos de CORS antes de que esta web salga, o el preflight falla.
 *
 * Solo a la API: los JSON de traducciones y demas archivos estaticos no lo
 * necesitan. La app Flutter hace lo mismo en su ApiClient.
 */
export const idiomaInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    if (!req.url.startsWith(environment.apiUrl) || req.headers.has('X-Lang')) {
        return next(req);
    }
    const idioma = inject(LanguageService).actual();
    return next(req.clone({ headers: req.headers.set('X-Lang', idioma) }));
};
